export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";